module.exports = __webpack_public_path__ + "static/img/template4.f1736d14.png";